export enum AppEnv {
	Sandbox = "sandbox",
	Live = "live",
}

export enum Duration {}

export enum ProcessorType {
	Stripe = "stripe",
	RevenueCat = "revenuecat",
}
